/*
* Hack to apply aria-labels to toolbar buttons and pickers
* per https://github.com/quilljs/quill/issues/1173
* until fixed by Quill
*/
const applyAriaToButtons = (toolBar) => {
    // apply aria labels to base buttons
    const buttons = toolBar.getElementsByTagName('button');
    for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i];
        const className = button.getAttribute('class').toLowerCase();

        if (className.indexOf('bold') >= 0) {
            button.setAttribute('aria-label', 'Toggle bold text');
        } else if (className.indexOf('italic') >= 0) {
            button.setAttribute('aria-label', 'Toggle italic text');
        } else if (className.indexOf('underline') >= 0) {
            button.setAttribute('aria-label', 'Toggle underline text');
        } else if (className.indexOf('blockquote') >= 0) {
            button.setAttribute('aria-label', 'Toggle blockquote text');
        } else if (className.indexOf('list') >= 0 && button.value === 'ordered') {
            button.setAttribute('aria-label', 'Toggle ordered list');
        } else if (className.indexOf('list') >= 0 && button.value === 'bullet') {
            button.setAttribute('aria-label', 'Toggle bulleted list');
        } else if (className.indexOf('link') >= 0) {
            button.setAttribute('aria-label', 'Toggle link');
        } else if (className.indexOf('ql-readMore') >= 0) {
            button.setAttribute('aria-label', 'Insert read more');
        } else if (className.indexOf('image') >= 0) {
            button.setAttribute('aria-label', 'Insert image');
        } else if (className.indexOf('clean') >= 0) {
            button.setAttribute('aria-label', 'Toggle remove formatting');
        }
    }
}

const applyAriaToPicker = (toolBar) => {
    // Make pickers work with keyboard and apply aria labels
    // FIXME: When you open a submenu with the keyboard and close it with the mouse by click somewhere else, the menu aria-hidden value is incorrectly left to `false`
    const pickers = toolBar.getElementsByClassName('ql-picker');
    for (let i = 0; i < pickers.length; i++) {
        const picker = pickers[i];

        const label = picker.getElementsByClassName('ql-picker-label')[0];
        const optionsContainer = picker.getElementsByClassName('ql-picker-options')[0];
        const options = optionsContainer.getElementsByClassName('ql-picker-item');

        label.setAttribute('role', 'button');
        label.setAttribute('aria-label', label.getAttribute('data-label') || 'menu')
        label.setAttribute('aria-haspopup', 'true');
        label.setAttribute('tabindex', '0');

        optionsContainer.setAttribute('aria-hidden', 'true');
        optionsContainer.setAttribute('aria-label', 'submenu');

        for (let x = 0; x < options.length; x++) {
            const item = options[x];
            item.setAttribute('tabindex', '0');
            item.setAttribute('role', 'button');

            // Read the css 'content' values and generate aria labels
            const size = window.getComputedStyle(item, ':before').content.replace('\"', '');
            item.setAttribute('aria-label', size);
            item.addEventListener('keyup', (e) => {
                if (e.keyCode === 13) {
                    item.click();
                    optionsContainer.setAttribute('aria-hidden', 'true');
                }
            });
        }

        label.addEventListener('keyup', (e) => {
            if (e.keyCode === 13) {
                label.click();
                optionsContainer.setAttribute('aria-hidden', 'false');
            }
        });
    }
}

/**
 *
 * @param {string} toolbarSelector Quill toolbar selector
 * @constructor
 */
const NUQuillAccessibilityPatch = (toolbarSelector= '.ql-toolbar') => {
    var toolbars = document.querySelectorAll(toolbarSelector);
    for (var i = 0; i < toolbars.length; i++) {
        applyAriaToButtons(toolbars[i]); // hack until fixed by quill https://github.com/quilljs/quill/issues/1173
        applyAriaToPicker(toolbars[i]);
    }
};

export default NUQuillAccessibilityPatch;
